// Marks a scrolling body with is-more while there is more of it below the
// fold, so the CSS stipples its foot only then. A screen that fits shows
// every pixel of itself.

// Under one pixel of scroll left counts as the end: a fractional scale on
// some phones leaves the last row a sub-pixel short.
const END_SLACK_PX = 1;

// One body is on the glass at a time. Its observer goes when the next body
// comes, or it would hold every replaced body alive for the whole stream.
let watching: ResizeObserver | null = null;

export function watchMore(body: HTMLElement): HTMLElement {
  const check = (): void => {
    const left = body.scrollHeight - body.clientHeight - body.scrollTop;
    body.classList.toggle('is-more', left > END_SLACK_PX);
  };
  body.addEventListener('scroll', check, { passive: true });
  watching?.disconnect();
  // The body's own box and its content both resize: a canvas lands, a list grows.
  watching = new ResizeObserver(check);
  watching.observe(body);
  for (const child of Array.from(body.children)) watching.observe(child);
  requestAnimationFrame(check);
  return body;
}
